import { mount } from './mount';

// Public API for the host page — reachable as `window.Island.*` (see the
// `library` setting in webpack.widget.js).
export { mount } from './mount';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount);
} else {
  mount();
}
